<template lang="pug">
//- nav(:data-visible="visible")
nav(:data-visible="visible", :class='{ top: type === "top", bottom: type === "bottom", "is-scrolling": isScrolling, "show--info": showInfo }')
  button.wrap-link(@click='navto("current")', :class="{ 'is-active': $route.name === 'Current' }")
    .heading Current
  button.wrap-link(@click='navto("projects")', :class="{ 'is-active': $route.name === 'Projects' }")
    .heading Projects
  button.wrap-link(@click='navto("info")', :class="{ 'is-active': $route.name === 'Info' }")
    .heading.desktop Information
    .heading.mobile Info
  //- router-link.heading(to="/news") News
</template>

<script>
// var Vue = require('vue')
// var VueScrollTo = require('vue-scrollto')
import VueScrollTo from 'vue-scrollto' // '@/scripts/scrollTo'

export default {
  name: 'Nav',
  props: ['visible', 'type', 'showInfo'],
  data () {
    return {
      isScrolling: false
    }
  },
  mounted () {
    let current = this.$router.currentRoute.name
    if (current === 'Projects') {
      setTimeout(() => {
        VueScrollTo.scrollTo('#projects', 1000, { container: '.main', offset: -50 })
      }, 1100)
    }
    else if (current === 'Info') {
      setTimeout(() => {
        this.navto("info")
      }, 1100);
    }
  },
  methods: {
    navto (target) {
      console.log('navto', target)
      this.isScrolling = true
      setTimeout(() => {
        this.isScrolling = false
      }, 1010)
      
      let current = this.$router.currentRoute.name
      // console.log(current)
      
      if (current === 'Info') {
        if (target === 'info') {
          console.log('open info 1');
          // this.$emit('openInfo')
          this.$parent.showInfo = true
        }
        // go back home
        this.$router.push({
          path: '/'+target,
          // replace: true
        })
        if (target === 'projects') {
          setTimeout(() => {
            VueScrollTo.scrollTo('#projects', 1000, { container: '.main', offset: -50 })
          }, 1020)
        }
        if (target === 'current') {
          setTimeout(() => {
            VueScrollTo.scrollTo('#current', 1000, { container: '.main' })
          }, 1020)
        }
      }
      
      else {
        // we're on the main page
        this.$router.push({
          path: '/'+target,
          replace: true
        }) 
        
        if (target === 'info') {
          // slide down the page to show info under it
          // ... the route watch does in in Projects.vue
          console.log('open info 2');
          this.$parent.showInfo = true
        } 
        else if (target === 'current') {
          // VueScrollTo.scrollTo('#app', 1000)
          VueScrollTo.scrollTo('#app', 1000, { container: '.main' })
        } 
        else if (target === 'projects') {
          // VueScrollTo.scrollTo('#projects', 1000)
          VueScrollTo.scrollTo('#projects', 1000, { container: '.main', offset: -50 })
        }
      }
      
      
      // else if (target === 'current') {
      //   const el = document.querySelector('#app')
      //   VueScrollTo.scrollTo(el, 1000)
        
      // } else if (target === 'projects') {
      //   const el = document.querySelector('#projects')
      //   setTimeout(() => {
      //     VueScrollTo.scrollTo(el, 1000)
          // this.$router.push({
          //   path: '/'+target,
          //   replace: true
          // })
      //   }, 1000)
      // }
      
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/variables';

nav {
  position:fixed;
  width:100%;
  height:$nav-h;
  display:flex;
  align-items: center;
  justify-content:space-around;
  /* border: 1px red solid; */
  button {
    color: black;
  }
  .heading {
    min-width: 10rem;
    /* font-size: 0.9rem; */
    color: black;
  }
  background: white;
  transition: background 1s ease-in-out;
  &.show--info {
    background: rgb(234, 234, 234);
    transition: background 1s ease-in-out;
  }
}
nav.top {
  top: 0;
  left: 0;
  z-index: 10;
}
nav.bottom{
  bottom:0; left:0;
  background:$color-bg;
}

/* a { */
button {
  display: inline-block;
  padding:0 2em;
  text-decoration: none;
  font-size: 1em;
  /* &.router-link-active{ */
  div {
    &:before{
      content:'';
      display:inline-block;
      width:em(6px, 9.5px);
      height:em(6px, 9.5px);
      background: transparent;
      margin-right:.25em;
    }
  }
  &.is-active div {
    &:before{
      background:$color-font;
    }
  }
  
  &:hover{
    font-style:normal;
  }
}

nav.is-scrolling button div {
  &:before{
    background: transparent !important;
  }
}


// show / hide
nav{
  visibility:hidden;
  button {
    transition: opacity .5s $trans-pageslide;
    opacity:0;
  }
  &[data-visible]{
    visibility:visible;
    button {
      opacity:1;
    }
  }  
}

.wrap-link {
  .desktop {
    display: block;
  }  
  .mobile {
    display: none;
  }
}

@include onMobile() {
  nav .wrap-link {
    // no wrap
    white-space: nowrap;
    padding: 0;
    font-size: 1rem;
    &:nth-child(1) .heading {
      text-align: left;
    }
    &:nth-child(2) .heading {
      text-align: center;
    }
    &:nth-child(3) .heading {
      text-align: right;
    }
    .heading {
      min-width: 20vw;
      /* background: pink; */
      /* transform: translateX(-0.8rem); */
    }
    .desktop {
      display: none;
    }  
    .mobile {
      display: block;
    }
  }
}

</style>


// WEBPACK FOOTER //
// Nav.vue?6818931a